import {useHistory} from "react-router-dom";
import {AuthContext} from '../context/AuthContext.js'
import {GeneralesContext} from '../context/GeneralesContext.js'
import SearchIcon from '@material-ui/icons/Search';
import {makeStyles} from '@material-ui/core/styles';
import { Box, Card, CardContent, FormControl, FormControlLabel,
    Grid, IconButton, InputLabel, Radio, RadioGroup, Select as MaterialSelect,
    TextField, Tooltip, Typography, LinearProgress } from '@material-ui/core'
import TablaUbicacion from './TablaUbicacion.jsx';
 
import moment from 'moment';
import axios from 'axios';
import qs from 'qs';
import {ErrorGeneral, llamadaApiToken, llamaApiCargaToken} from '../funciones/ClienteAxios.jsx';
import React, {useContext, useEffect, useState} from "react";
import ModNvoEditMaquina from './NvoEditUbic.jsx'
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import ReplayIcon from '@material-ui/icons/Replay';
const useStyles = makeStyles((theme) => ({
    title2: {
        fontSize: 18,
    },
    subTitle2: {
        fontSize: 12,
    },
    altura2: {
        minHeight: 70,
        marginTop: 0,
        paddingTop: 0,
    },
    altura3: {
        minHeight: 145,
        marginTop: 0,
        paddingTop: 0,
    },

}));


const CatalogoMarca = () => {
    let history = useHistory();
    const classes = useStyles();
    const idusu = localStorage.getItem('UsuId');
    const source = axios.CancelToken.source();
 
    const {usuario, guardarUsuario} = useContext(AuthContext);
    const {guardarGenerales} = useContext(GeneralesContext);
    const [listBit, setListBit] = useState([])
    const [ordenBusq, setOrdenBusq] = useState({orden: '', turno: ''});
    const [fechasSeleccionadas, setFechasSeleccionadas] = useState({inicio: new Date(), final: new Date()});
    const {orden, turno} = ordenBusq;
    const [estatus, setEstatus] = useState(-2);
    const [buscar, setBuscar] = useState(true);
    const [terminal, setTerminal] = useState([]);
    const [listMaquinaria, setListMaquinaria] = useState([])
    const [listUbi, setListUbi] = useState([])
    const [modalAbierto, setModalAbierto] = useState(false);
    const [esperaTabBit, setEsperaTabBit] = useState(false);
    const [modalNvo, setModalNvo] = useState(false);
    const [espera, setEspera] = useState(false);
    const[filtro,setFiltro] = useState({supervisa:false})
    const[filtroSerie,setFiltroSerie] = useState("")
    const[filtroNoEco,setFiltroNoEco] = useState("")
    const[filtroDescr,setFiltroDescr] = useState("")
    const{supervisa}=filtro

    useEffect(() => {                       

        const veriSesion = () => {
            const usu = localStorage.getItem('UsuarioNom');
            const nvl = localStorage.getItem('Tipo');
            if (usu === null) {
                guardarUsuario([])
                guardarGenerales([])
                localStorage.clear();
                history.push("/")
            } else {
                if (usuario.length === 0) {
                    guardarUsuario({Nombre: usu, nivel: nvl});
                }

                guardarGenerales({Titulo: 'Catálogo Ubicación'})
                               
            }
        }
        veriSesion();
        return () => {
            source.cancel();
        }
    }, []);

    useEffect(()=>{
        getListUbi() 
    },[buscar])
 

    const getListUbi = () => {
        const data = qs.stringify({
            Usuario: idusu,
            ip: "127.0.0.0",
            idDispositivo: '89y7gttvjhj98h'
        });
        const url = "/maquinaria/ubicacion";

        function respuestaListTermin(aux) {
            if (aux[0].Id !== -1) {                
                setListUbi(aux)
            }
        }

        llamaApiCargaToken(data, url, respuestaListTermin, ErrorGeneral, setEspera, history, source)
    };    

    const llamarUbicacionOrd = () => {
        const data = qs.stringify({
            tipo: 'ORD',
            idDispositivo: '89y7gttvjhj98h'
        });
        const url = "/lugar-ubicacion-list-1_1";

        function respuestaListInterv(auxiliar) {
            if (auxiliar[0].Id !== -1) {
                localStorage.setItem('LisUbicOrd', JSON.stringify(auxiliar));
            }
        }

        llamadaApiToken(data, url, respuestaListInterv, ErrorGeneral, history, source);
    };

    const onChange = e => {
        let expNopermitida = new RegExp('[#._:$!%-({})/*=?|]');
        let expMenos = new RegExp('-');
        let expMas = new RegExp('[+]');
        let expCadena = new RegExp('[A-Za-z0-9]');
        if ((expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) &&
            !expMenos.test(e.target.value) && !expMas.test(e.target.value)) || e.target.value === ' ' || e.target.value === '') {
            setFiltroNoEco( e.target.value.trim()
            )
        }

    };

    const onChange2 = e => {
        let expNopermitida = new RegExp('[#._:$!%-({})/*=?|]');
        let expMenos = new RegExp('-');
        let expMas = new RegExp('[+]');
        let expCadena = new RegExp('[A-Za-z0-9]');
        if ((expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) &&
            !expMenos.test(e.target.value) && !expMas.test(e.target.value)) || e.target.value === ' ' || e.target.value === '') {
            
                setFiltroSerie( e.target.value.trim())
            
        }

    };

    const onChange3 = e => {
        let expNopermitida = new RegExp('[#._:$!%-({})/*=?|]');
        let expMenos = new RegExp('-');
        let expMas = new RegExp('[+]');
        let expCadena = new RegExp('[A-Za-z0-9]');
        if ((expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) &&
            !expMenos.test(e.target.value) && !expMas.test(e.target.value)) || e.target.value === ' ' || e.target.value === '') {
            
            setFiltroDescr( e.target.value.trim())
            
        }

    };
    const funcionActualizar = e => {
        setBuscar(!buscar)
    };

    const onChangeTerminal = (event) => {
        setTerminal(event.target.value);
    };


    function tipoEstado(estado) {
        let auxEtiqueta = ''
        let auxColor = ''
        if (estado === 0) {
            auxEtiqueta = 'Registrado'
            auxColor = '#F46239'
        } else {
            if (estado === 1) {
                auxEtiqueta = 'Solucionado'
                auxColor = '#049b4f'
            } else {
                if (estado === -1) {
                    auxEtiqueta = 'Cancelado'
                    auxColor = 'red'
                }
            }
        }
        let renglon = {color: auxColor, etiqueta: auxEtiqueta}
        return renglon
    }

    const Encabezado = ({espacio, estiloCampo, descripcion, campo}) => {
        return (
        <Box {...espacio} >
            <Typography className={classes.title2} variant="h5" color="secondary"
                component="h2" align="center" style={estiloCampo}
            >
                {campo}
            </Typography>
            <Typography className={classes.subTitle2} color="textSecondary" align="center">
                {descripcion}
            </Typography>
        </Box>
        )
    }

    const CampoRenglon = ({estiloBox, estiloTitulo, titulo, campo}) => {
        return (
            <Box  {...estiloBox} >
                <span style={estiloTitulo}>{titulo} </span>
                <Typography variant='body'> {campo}  </Typography>
            </Box>
        )
    }

    const costadoDerecho = (orden) => {
        let fecha = moment.utc(orden.fecha);
        let modificada = fecha.local(true).format("DD/MM/YYYY");        
        const colorTitulo = process.env.REACT_APP_COLOR        
        return (
            <span>
        <Box pl={1} my={1}>
            <Card  >
                <CardContent>
                    <Box display="flex" flexDirection="row" justifyContent="center">
                        <Encabezado espacio={{}} estiloCampo={{fontWeight: '900'}} descripcion={"OT"} campo={orden.Id}/>
                        <Encabezado espacio={{ml: 1}} estiloCampo={{fontWeight: '900'}}
                            descripcion={"Periodo"} campo={orden.periNom}/>
                        {/* <Encabezado espacio={{ml: 1}} estiloCampo={{fontWeight: '900'}}
                                    descripcion={"Sección"} campo={orden.seccNom}/> */}
                        <Encabezado espacio={{ml: 1}} estiloCampo={{fontWeight: '900'}}
                                    descripcion={"Lugar"} campo={orden.lugarDescr}/>
                        <Encabezado espacio={{ml: 1}} estiloCampo={{fontWeight: '900'}}
                                    descripcion={"Fecha"} campo={modificada}/>                                                           
                    </Box>
                    {orden.refManual.length !== 0 && orden.refManual !== ' ' ?
                        <CampoRenglon estiloBox={{display: "flex"}} titulo="Ref. Manual " campo={orden.refManual}
                                      estiloTitulo={{color: colorTitulo, fontWeight: 700, paddingRight: 0.2 + 'rem'}}
                        />
                        : null}
                    {orden.ubicDescr.length !== 0 ?
                        <CampoRenglon estiloBox={{display: "flex"}} titulo="Ubicación " campo={orden.ubicDescr}
                                      estiloTitulo={{color: colorTitulo, fontWeight: 700, paddingRight: 0.2 + 'rem'}}
                        />
                        : null}                    
                </CardContent>                     
            </Card>
        </Box>                    
                          
    </span>)
    }

    const funcionActuliza = () => {
        setBuscar(!buscar)
    }

    function handleAbrir() {
        setModalNvo(true)
    }

    const onChangeCheck = (event) => {
        setFiltro({
          ...filtro,
            [event.target.name]: event.target.checked 
          });
    };

    
    const principal = () => {
        return (
        <>
        <Grid container alignItems={'flex-start'} style={{marginTop: '.5rem', marginBottom: '.5rem'}}>
            <Grid item xs={12}>
                <Card className={classes.altura2}>
                    <CardContent style={{padding: '.5rem'}}>
                        <Box   display="flex" alignItems={'center'} flexDirection={"row"} >
                            
                            <Box  >
                                <Tooltip title="Actualizar">
                                <IconButton color="primary" size={"small"} onClick={funcionActuliza}
                                    style={{paddingTop: '.6rem'}}>
                                    <ReplayIcon/>
                                </IconButton>
                                </Tooltip>
                            </Box>                     
                           <Box mx={1} >
                                <Tooltip title="Nueva Ubicación">
                               <IconButton size={"small"} color="primary" onClick={() => handleAbrir()}
                                    style={{paddingTop: '.6rem'}}>
                                    <AddCircleOutlineIcon/>
                                </IconButton>
                                </Tooltip>
                            </Box>    
                            {listUbi.length !==0 ? 
                                <TextField id="outlined-basic" label="Filtrar por Nombre" variant="outlined" size="small"                            
                                    name="filtroDescr" value={filtroDescr} onChange={onChange3}/>
                            :null}
                                   
                            {/* <Grid item>
                                <TextField id="outlined-basic" label="Folio" variant="outlined" size="small"
                                    name="orden" value={orden} onChange={onChange}/>
                            </Grid> */}
                    </Box>
                </CardContent>
            </Card>
            </Grid>
        </Grid>

        <Grid container  alignItems={'flex-start'} >
            <Grid item xs={10}>
                {espera ? 
                    (<Box mt={5} ml={2}><LinearProgress/> </Box>) 
                :   <TablaUbicacion                         
                        listUbi={listUbi}                                                
                        filtroSerie={filtroSerie}
                        filtroNoEco={filtroNoEco}
                        filtroDescr={filtroDescr}
                        funcionActualizar={funcionActualizar}
                    />
                }
            </Grid>
             
        </Grid>
        </>
        )
    }

    const modNvo = modalNvo ? <ModNvoEditMaquina  modalAbierto={modalNvo} setModalAbierto={setModalNvo} 
        titulo={`Nueva Ubicación`} regis={[]} funcionActuliza={funcionActuliza} /> :null
    return (
    <>
        {modNvo}
        {principal()}
        
    </>
    )
}

export default CatalogoMarca